.custom-carousel {
  &.carousel-root,
  .carousel,
  .slider-wrapper,
  .slider,
  .slide,
  .carousel-item-wrapper,
  .carousel-item-wrapper img,
  .carousel .slide iframe {
    height: 100%;
  }

  .carousel-item-wrapper img {
    object-fit: cover;
  }

  .carousel .slide iframe {
    margin: 0;
    padding: 30px;
    aspect-ratio: 16 / 9;
  }

  .carousel.carousel-slider {
    border-radius: 20px;
  }

  @media (max-width: 950px) {
    .carousel .slide iframe {
      padding: 0;
      width: 100%;
    }
    .carousel.carousel-slider {
      border-radius: 0;
    }
  }
}
